// External Imports
import get from 'lodash/fp/get.js';
import set from 'lodash/fp/set.js';
import { compile } from 'path-to-regexp';
import { createSelector } from 'reselect';

// Internal Imports
import { selectActivePagination } from './selectActivePagination.mjs';
import { selectContentArchiveItems } from './selectContentArchive.mjs';
import { selectMatch } from './selectMatch.mjs';
import { selectPathMap } from './selectPathMap.mjs';

// Local Functions
const selectLandingPageItem = createSelector(
  [get('landingPage'), get('contentItem.landing-page.byId')],
  (landingPageId, landingPagesById) =>
    landingPagesById ? landingPagesById[landingPageId] : undefined,
);

/**
 * Selector that will return a landing page entity
 *
 * @param {string} type landing page type
 * @return {function}   selector function
 */
const selectLandingPage = createSelector(
  [
    selectLandingPageItem,
    selectActivePagination,
    selectPathMap,
    selectContentArchiveItems,
    selectMatch,
  ],
  (landingPage, pagination, pathMap, relatedItems, { params, pathType }) => {
    if (!landingPage) {
      return;
    }
    const landingPageToPath = compile(pathMap[pathType]);
    const { currentPage, totalPages } = pagination;

    // eslint-disable-next-line consistent-return -- optional return
    return {
      item: set('path', landingPageToPath({ ...params }), landingPage),
      pagination: set(
        'hasMore',
        totalPages ? totalPages > 1 && currentPage < totalPages : false,
        pagination,
      ),
      relatedItems,
    };
  },
);

// Module Exports
export { selectLandingPage };
